import creditoService from '@/servicios/credito'
import { ERROR_INSERTAR_DOCUMENTOS } from '@/utilidades/errores'

export const InsertaDocumentosSolicitudMixin = {
  data: () => ({
    consumiendoInsertaDocumentos: false,
  }),
  methods: {
    // Metodos publicos
    insertaDocumentosSolicitud(request) {
      this.$_InsertaDocumentosSolicitudMixin_IniciaInsertaDocumentosSolicitud()
      creditoService
        .insertaDocumentos(request)
        .then((result) => {
          this.$_InsertaDocumentosSolicitudMixin_TerminaInsertaDocumentosSolicitud()
          if (result.status != 200) {
            this.errorInsertaDocumentosSolicitud(ERROR_INSERTAR_DOCUMENTOS)
            return
          }
          const data = result.data
          if (data.Codigo != 200) {
            this.errorInsertaDocumentosSolicitud(data.Mensaje)
            return
          }
          this.postInsertaDocumentosSolicitud(data.Modelo)
        })
        .catch((err) => {
          this.$_InsertaDocumentosSolicitudMixin_TerminaInsertaDocumentosSolicitud()
          console.error(err)
          this.errorInsertaDocumentosSolicitud(ERROR_INSERTAR_DOCUMENTOS)
        })
    },
    postInsertaDocumentosSolicitud() {},
    errorInsertaDocumentosSolicitud(mensaje) {
      console.error(mensaje)
    },

    // Metodos privados
    $_InsertaDocumentosSolicitudMixin_IniciaInsertaDocumentosSolicitud() {
      this.consumiendoInsertaDocumentos = true
    },
    $_InsertaDocumentosSolicitudMixin_TerminaInsertaDocumentosSolicitud() {
      this.consumiendoInsertaDocumentos = false
    },
  },
}
